import { tr } from "../i18n/LanguageContext";
// Human-readable Russian message from a FastAPI error body (detail may be a string or a 422 list).
export const apiErrorMessage = (data, fallback) => {
  const detail = data?.detail;
  if (typeof detail === "string" && detail) return tr(detail);
  if (Array.isArray(detail) && detail.length) {
    const field = Array.isArray(detail[0]?.loc) ? detail[0].loc.slice(-1)[0] : "";
    if (field === "email") return tr("Введите корректный адрес электронной почты");
  }
  return fallback;
};
